import { SectionBankAccountItem } from "@/models/api/orders/temporary/OrderGetTemporaryOrderSection";
import { Expose, Type } from "class-transformer";
import { IsNumber, IsOptional, IsString, ValidateNested, IsBoolean, IsEnum } from "class-validator";
import { FormOfPaymentItem } from "@/models/api/FormOfPaymentItem";
import { CHANGE_REASON } from "@/static/changeReasonEnum";

export class OrderCommentData {
  @IsString()
  @Expose()
  comment!: string;

  @IsBoolean()
  @Expose()
  isCorrection!: boolean;

  @IsOptional()
  @IsEnum(CHANGE_REASON)
  @Expose()
  internalChangeReasonId?: CHANGE_REASON | null;
  @IsOptional()
  @IsString()
  @Expose()
  changeReasonDescription?: string | null;

  @IsNumber()
  @Expose()
  formOfPaymentId!: number;
  @Type(() => FormOfPaymentItem)
  @ValidateNested()
  @Expose()
  formOfPayments!: Array<FormOfPaymentItem>;

  @IsOptional()
  @IsNumber()
  @Expose()
  bankAccountId?: null | number;
  @Type(() => SectionBankAccountItem)
  @ValidateNested()
  @Expose()
  bankAccounts!: Array<SectionBankAccountItem>;
}

export class EditOrderCommentData {
  @IsString()
  @Expose()
  comment!: string;
  @IsOptional()
  @IsNumber()
  @Expose()
  internalChangeReasonId?: CHANGE_REASON | null;
  @IsOptional()
  @IsString()
  @Expose()
  changeReasonDescription?: string | null;
  @IsNumber()
  @Expose()
  formOfPaymentId!: number;
  @IsOptional()
  @IsNumber()
  @Expose()
  bankAccountId?: null | number;
}

export class FastCorrectionData {
  @IsString()
  @Expose()
  comment!: string;
  @IsOptional()
  @IsString()
  @Expose()
  changeReasonDescription?: string | null;
  @IsOptional()
  @IsNumber()
  @Expose()
  internalChangeReasonId?: CHANGE_REASON | null;
}
